angular.module('taric.adco.view', ['taric.model.additional-code'])
    .controller('ViewAdcoController', function (additionalCode, simulationDate, CONSTANTS, AdditionalCodePopupModel, $uibModal) {
        var viewAdcoCtrl = this;

        viewAdcoCtrl.init = function () {
            viewAdcoCtrl.dateFormat = CONSTANTS.dateFormat;
            viewAdcoCtrl.installationCountry = CONSTANTS.installationCountry;
            viewAdcoCtrl.selectedRow = additionalCode;
            viewAdcoCtrl.descriptionLanguages = [];
            if (viewAdcoCtrl.selectedRow) {
                // Sort languages of additional code descriptions
                for (let lang in viewAdcoCtrl.selectedRow.descriptions) {
                    viewAdcoCtrl.descriptionLanguages.push(lang);
                }
                viewAdcoCtrl.descriptionLanguages.sort();
            }
        };

        viewAdcoCtrl.openFootnotePopup = function (size, footnoteId) {
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
                controller: 'FootnotePopupController as footnotePopupCtrl',
                size: size,
                resolve: {
                    footnote: function (FootnotePopupModel) {
                        return FootnotePopupModel.findFootnote(footnoteId, simulationDate);
                    }
                }
            });
        };
    });


// WEBPACK FOOTER //
// ./app/taric/adco/view/adco-view.js